import styled from "styled-components";
import Text from "../Text";

/**
 * @author jaeho.lee104 on 2023. 08. 08..
 */
const NewP4 = styled(Text)`
  font-feature-settings: 'clig' off, 'liga';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export default NewP4;